import React, {Component} from 'react';
import UserProfileLogo from './userProfileLogo';
import IconButton from 'material-ui/IconButton';
import HelpOutline from 'material-ui-icons/HelpOutline'

class Header extends Component {
    render () {
        return (
            <div>
                <header  className="an-header">
                    {this.props.loggedIn ?
                        <div>
                            <img alt="Vibo logo" src="https://s3.eu-central-1.amazonaws.com/vibo-public/wwwroot/images_static/vibo-logo-trns.png"/>
                            <div className = "header-right">
                                <IconButton>
                                    <HelpOutline
                                        className = "help-button"
                                        onClick = {this.props.handleSupportButtonClicked}
                                    />
                                </IconButton>
                                <UserProfileLogo logout = {this.props.logout}/>
                            </div>
                        </div>
                        : null}
                </header>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.component.js